import styled from '@emotion/styled'
import { MediaQuery } from '@pharmac-extranet/shared'
import { PharmacIcon, PharmacIconProps } from '@pharmac/ui'
import { useNavigate } from 'react-router-dom'
import { RouterPaths } from '../../router/i18n/extranet-routes'
import { useExtranetPath } from '../../router/useExtranetPath'

const ShortcutButtonRoot = styled.div`
  width: calc(50% - var(--spacing-small));
  height: calc(300px * 0.5 - var(--spacing-small));
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding: var(--spacing-small);

  border-radius: var(--border-radius-tiny);
  box-shadow: 4.07px 4.07px 6px 0px #00000040;

  ${MediaQuery.maxTablet} {
    width: 20%;
  }

  transition: var(--transition-cubic-bezier);

  @media (max-width: 600px) {
    width: calc(50% - var(--spacing-medium));
    height: calc(300px * 0.45 - var(--spacing-small));
  }

  background: var(--color-accent-2);

  :hover {
    box-shadow: 6px 6px 10px 1px #00000040;
    transform: translate3d(-2px, -4px, 0px);

    background-color: var(--extranet-light-purple);
  }
`

const ShortcutButton = styled.button`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const ShortcutButtonButtonIcon = styled.div`
  width: 100%;
  text-align: center;
  color: var(--color-primary);
  height: 40px;
`
const ShortcutButtonButtonText = styled.div`
  width: 100%;
  text-align: center;
  font-family: var(--font-family-secondary);
  font-size: var(--typo-h5-size);
  color: var(--color-primary);
  font-weight: 700;
`

export type ExtranetShortcutButtonProps = {
  title: string
  icon: PharmacIconProps['icon']
  url: keyof RouterPaths
}

export const FrontpageShortcut = ({ title, icon, url }: ExtranetShortcutButtonProps) => {
  const navigate = useNavigate()

  const createPath = useExtranetPath()

  return (
    <ShortcutButtonRoot>
      <ShortcutButton onClick={() => navigate(createPath(url))}>
        <ShortcutButtonButtonIcon>
          <PharmacIcon
            icon={icon}
            size="35"
          />
        </ShortcutButtonButtonIcon>
        <ShortcutButtonButtonText dangerouslySetInnerHTML={{ __html: title }} />
      </ShortcutButton>
    </ShortcutButtonRoot>
  )
}
